<template>
    <div>
        <form class="add-food-from-db">
            <div class="modal-search-wrapper input-wrapper">
                <input
                    id="modal-search"
                    type="search"
                    name="search"
                    v-model="searchInput"
                    v-on:keyup="search"
                    placeholder="Sök livsmedel..."
                    class="modal-input search-input input-field"
                />

                <img id="search-icon" src="/assets/images/diary-icons/search.svg" alt="" />

                <div v-if="isSearching && searchInput.length > 0" class="search-loading-spinner">
                    <beat-loader color="#ef61a7" size="6px"></beat-loader>
                </div>

                <button
                    v-if="searchInput && !isSearching"
                    type="button"
                    class="reset-search-btn"
                    @click="reset"
                >
                    <img src="/assets/images/diary-icons/times-pink-larger.svg" alt="" />
                </button>
            </div>
        </form>

        <div class="search-results">
            <div v-if="error" class="alert alert-danger">
                {{ error }}
            </div>

            <div
                v-if="results.length === 0 && !isSearching && searchInput.length > 0 && hasDataLoaded"
                class="text-center my-3"
            >
                Inga resultat
            </div>

            <div v-if="results.length > 0 && hasDataLoaded" class="modal-search-results">
                <div class="search-result-category">
                    <h4>Livsmedel:</h4>

                    <div v-for="item in results" :key="item.id" class="search-result-item">
                        <a href="#" @click.prevent="attach(item.id)" class="item-name">
                            {{ item.name }}
                            <span class="item-kcal">({{ item.kcal }} kcal)</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

export default {
    components: {
        BeatLoader
    },

    data() {
        return {
            debounce: null,
            debounceTimer: 500,
            ...this.defaultState()
        };
    },

    methods: {
        attach(id) {
            this.isSearching = true;
            this.error = null;

            axios
                .post('/matdagbok/livsmedel/attach', { id })
                .then(() => {
                    window.location.href = `/matdagbok/livsmedel/redigera/${id}`;
                })
                .catch(() => {
                    this.error = 'Kunde inte redigera livsmedlet.';
                    this.isSearching = false;
                });
        },

        reset: function () {
            Object.assign(this.$data, this.defaultState());
        },

        defaultState: function () {
            return {
                searchInput: '',
                results: [],
                isSearching: false,
                error: null,
                hasDataLoaded: false,
                checkboxes: {
                    db1: true,
                    db2: true
                }
            };
        },

        search: function () {
            if (this.searchInput.length < 3) {
                this.hasDataLoaded = false;
                this.results = [];
                return;
            }

            clearTimeout(this.debounce);

            this.debounce = setTimeout(() => {
                this.isSearching = true;

                axios
                    .get('/api/food-item-search', {
                        params: {
                            search: this.searchInput
                        }
                    })

                    .then((response) => {
                        console.log('API response:', response.data);

                        this.results = response.data;
                        this.error = null;
                        this.hasDataLoaded = true;
                    })

                    .catch((error) => {
                        this.error = 'Något gick fel, försök igen!';
                        console.log(error);
                    })

                    .finally(() => {
                        this.isSearching = false;
                    });
            }, this.debounceTimer);
        }
    },

    mounted() {
        $('#add-food-from-db').on('hide.bs.modal', (e) => {
            Object.assign(this.$data, this.defaultState());
        });

        $('#add-food-from-db').on('shown.bs.modal', (e) => {
            this.$nextTick(() => {
                const input = document.getElementById('modal-search');
                input.focus();
            });
        });
    }
};
</script>
